export const pricingContent = {
  hero: {
    title: "Simple Family Pricing",
    subtitle: "One plan. Every feature. No surprises.",
    cta: {
      primary: "Join the Beta",
      primaryLink: "/beta",
      secondary: "Learn More",
      secondaryLink: "/about"
    }
  },
  pricingSummary: {
    title: "The Family Plan",
    basePrice: "$9",
    basePriceLabel: "/month",
    tagline: "Everything your family needs. Nothing you don't.",
    highlights: [
      { text: "3 screens included", emphasis: true },
      { text: "Every feature unlocked", emphasis: true },
      { text: "No tiers, no upsells", emphasis: false },
      { text: "First 30 days free", emphasis: false }
    ],
    additionalScreens: {
      price: "+$3",
      label: "per extra screen",
      description: "Growing family? Just add more screens whenever you need them."
    },
    noGating: "We don't gate features. Ever. You get everything from day one.",
    cta: {
      text: "Join the Beta",
      link: "/beta"
    }
  },
  additionalProducts: {
    title: "Coming Soon: Add-On Products",
    subtitle: "Optional add-ons to make family life even easier",
    products: [
      {
        iconName: "EmojiEvents",
        title: "Chore & Reward Board",
        description: "Assign chores, track completion, and reward your kids for helping out. Make household tasks fun!",
        status: "Under Active Development"
      },
      {
        iconName: "Restaurant",
        title: "Meal Planning",
        description: "Plan your weekly meals, generate shopping lists, and display what's for dinner on your family screens.",
        status: "Under Active Development"
      }
    ]
  },
  // Note: howItWorks section removed - content consolidated into hero highlights
  custom: {
    title: "Need Something Special?",
    subtitle: "Got a unique family setup? Multiple households? Shared custody schedules? Let's build something perfect for you!",
    description: "Every family is different, and we love helping create custom solutions that work exactly how you need them to. Let's chat about what would make your family life easier!",
    features: [
      {
        iconName: "People",
        title: "Family-First Support",
        description: "Real humans who understand busy families and actually want to help! 💙"
      },
      {
        iconName: "IntegrationInstructions",
        title: "Connect Your Way",
        description: "Already using specific apps? We can connect them so everything works together seamlessly!"
      },
      {
        iconName: "DisplaySettings",
        title: "Make It Yours",
        description: "Customize colors, themes, and branding to match your family's style!"
      }
    ],
    cta: "Let's Chat About Your Needs"
  }
};
